import React from 'react';
import CreatableSelect from 'react-select/creatable';

import CustomDropdown from '@/components/CustomDropdown';

const Input = () => {
	return (
		<div>
			<div className="container">
				{/* Start Input  */}
				<section className="p-5">
					<div className="row">
						<div className="col-md-12">
							<h5 className="mt-5">Default----42 PX</h5>
						</div>
						<div className="col-md-6">
							<div className="form-group">
								<label htmlFor>Label Text</label>
								<input placeholder="Placeholder Text" type="text" />
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group size36">
								<label htmlFor>Label Text</label>
								<select id name>
									<option value>1</option>
									<option value>2</option>
									<option value>2</option>
								</select>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group">
								<label htmlFor>Label Text</label>
								<div className="with-icon left-icon right-icon">
									<span className="left-icon">
										<svg
											fill="none"
											height={17}
											viewBox="0 0 18 17"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M16.6484 6.04L11.8084 5.62L9.91836 1.17C9.57836 0.36 8.41836 0.36 8.07836 1.17L6.18836 5.63L1.35836 6.04C0.478364 6.11 0.118364 7.21 0.788364 7.79L4.45836 10.97L3.35836 15.69C3.15836 16.55 4.08836 17.23 4.84836 16.77L8.99836 14.27L13.1484 16.78C13.9084 17.24 14.8384 16.56 14.6384 15.7L13.5384 10.97L17.2084 7.79C17.8784 7.21 17.5284 6.11 16.6484 6.04ZM8.99836 12.4L5.23836 14.67L6.23836 10.39L2.91836 7.51L7.29836 7.13L8.99836 3.1L10.7084 7.14L15.0884 7.52L11.7684 10.4L12.7684 14.68L8.99836 12.4Z"
												fill="#9AA1AF"
											/>
										</svg>
									</span>
									<input placeholder="Placeholder Text" type="text" />
									<span className="right-icon">
										<svg
											fill="none"
											height={17}
											viewBox="0 0 18 17"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M16.6484 6.04L11.8084 5.62L9.91836 1.17C9.57836 0.36 8.41836 0.36 8.07836 1.17L6.18836 5.63L1.35836 6.04C0.478364 6.11 0.118364 7.21 0.788364 7.79L4.45836 10.97L3.35836 15.69C3.15836 16.55 4.08836 17.23 4.84836 16.77L8.99836 14.27L13.1484 16.78C13.9084 17.24 14.8384 16.56 14.6384 15.7L13.5384 10.97L17.2084 7.79C17.8784 7.21 17.5284 6.11 16.6484 6.04ZM8.99836 12.4L5.23836 14.67L6.23836 10.39L2.91836 7.51L7.29836 7.13L8.99836 3.1L10.7084 7.14L15.0884 7.52L11.7684 10.4L12.7684 14.68L8.99836 12.4Z"
												fill="#9AA1AF"
											/>
										</svg>
									</span>
								</div>
								<div className="helper-text">
									<div className="left">
										<svg
											fill="none"
											height={14}
											viewBox="0 0 14 14"
											width={14}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M6.00184 2.25179L1.06101 10.5001C0.959139 10.6765 0.905238 10.8765 0.904668 11.0803C0.904097 11.284 0.956877 11.4843 1.05776 11.6613C1.15864 11.8382 1.3041 11.9857 1.47967 12.089C1.65524 12.1923 1.85481 12.2479 2.05851 12.2501H11.9402C12.1439 12.2479 12.3434 12.1923 12.519 12.089C12.6946 11.9857 12.84 11.8382 12.9409 11.6613C13.0418 11.4843 13.0946 11.284 13.094 11.0803C13.0934 10.8765 13.0395 10.6765 12.9377 10.5001L7.99684 2.25179C7.89285 2.08035 7.74643 1.93861 7.57171 1.84024C7.39698 1.74186 7.19985 1.69019 6.99934 1.69019C6.79883 1.69019 6.6017 1.74186 6.42698 1.84024C6.25225 1.93861 6.10583 2.08035 6.00184 2.25179V2.25179Z"
												stroke="#6A7181"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M7 5.25V7.58333"
												stroke="#6A7181"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M7 9.91666H7.00583"
												stroke="#6A7181"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</svg>
										<span>Helper Text</span>
									</div>
									<div className="right">5/10</div>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group">
								<label htmlFor>Label Text</label>
								<div className="with-icon left-icon">
									<span className="left-icon">
										<svg
											fill="none"
											height={17}
											viewBox="0 0 18 17"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M16.6484 6.04L11.8084 5.62L9.91836 1.17C9.57836 0.36 8.41836 0.36 8.07836 1.17L6.18836 5.63L1.35836 6.04C0.478364 6.11 0.118364 7.21 0.788364 7.79L4.45836 10.97L3.35836 15.69C3.15836 16.55 4.08836 17.23 4.84836 16.77L8.99836 14.27L13.1484 16.78C13.9084 17.24 14.8384 16.56 14.6384 15.7L13.5384 10.97L17.2084 7.79C17.8784 7.21 17.5284 6.11 16.6484 6.04ZM8.99836 12.4L5.23836 14.67L6.23836 10.39L2.91836 7.51L7.29836 7.13L8.99836 3.1L10.7084 7.14L15.0884 7.52L11.7684 10.4L12.7684 14.68L8.99836 12.4Z"
												fill="#9AA1AF"
											/>
										</svg>
									</span>
									<input placeholder="Placeholder Text" type="text" />
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group">
								<label htmlFor>Label Text</label>
								<div className="with-icon right-icon">
									<input placeholder="Placeholder Text" type="text" />
									<span className="right-icon">
										<svg
											fill="none"
											height={17}
											viewBox="0 0 18 17"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M16.6484 6.04L11.8084 5.62L9.91836 1.17C9.57836 0.36 8.41836 0.36 8.07836 1.17L6.18836 5.63L1.35836 6.04C0.478364 6.11 0.118364 7.21 0.788364 7.79L4.45836 10.97L3.35836 15.69C3.15836 16.55 4.08836 17.23 4.84836 16.77L8.99836 14.27L13.1484 16.78C13.9084 17.24 14.8384 16.56 14.6384 15.7L13.5384 10.97L17.2084 7.79C17.8784 7.21 17.5284 6.11 16.6484 6.04ZM8.99836 12.4L5.23836 14.67L6.23836 10.39L2.91836 7.51L7.29836 7.13L8.99836 3.1L10.7084 7.14L15.0884 7.52L11.7684 10.4L12.7684 14.68L8.99836 12.4Z"
												fill="#9AA1AF"
											/>
										</svg>
									</span>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="input-group mb-3">
								<div className="input-group-prepend">
									<button
										aria-expanded="false"
										aria-haspopup="true"
										className="btn btn-outline-secondary dropdown-toggle"
										data-toggle="dropdown"
										type="button"
									>
										Dropdown
									</button>
									<div className="dropdown-menu">
										<a className="dropdown-item" href="#">
											Action
										</a>
										<a className="dropdown-item" href="#">
											Another action
										</a>
										<a className="dropdown-item" href="#">
											Something else here
										</a>
									</div>
								</div>
								<input
									aria-label="Text input with dropdown button"
									className="form-control"
									type="text"
								/>
							</div>
						</div>
						<div className="col-md-6">
							<div className="input-group">
								<input
									aria-label="Text input with dropdown button"
									className="form-control"
									type="text"
								/>
								<div className="input-group-append">
									<button
										aria-expanded="false"
										aria-haspopup="true"
										className="btn btn-outline-secondary dropdown-toggle"
										data-toggle="dropdown"
										type="button"
									>
										Dropdown
									</button>
									<div className="dropdown-menu">
										<a className="dropdown-item" href="#">
											Action
										</a>
										<a className="dropdown-item" href="#">
											Another action
										</a>
										<a className="dropdown-item" href="#">
											Something else here
										</a>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="input-group mb-3">
								<div className="input-group-prepend with-color-element">
									<button
										aria-expanded="false"
										aria-haspopup="true"
										className="btn btn-outline-secondary dropdown-toggle"
										data-toggle="dropdown"
										type="button"
									>
										<span
											className="color"
											style={{
												background: 'rgba(255, 123, 118, 1) none repeat scroll 0% 0%'
											}}
										/>
										TCX-GHX23
									</button>
									<div className="dropdown-menu">
										<a className="dropdown-item" href="#">
											Action
										</a>
										<a className="dropdown-item" href="#">
											Another action
										</a>
										<a className="dropdown-item" href="#">
											Something else here
										</a>
									</div>
								</div>
								<input
									aria-label="Text input with dropdown button"
									className="form-control"
									type="text"
								/>
								<span className="action-icon">
									<svg
										fill="none"
										height={18}
										viewBox="0 0 19 18"
										width={19}
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M2.75 4.5H4.25H16.25"
											stroke="#F82B60"
											strokeLinecap="round"
											strokeLinejoin="round"
											strokeWidth="1.5"
										/>
										<path
											d="M6.5 4.5V3C6.5 2.60218 6.65804 2.22064 6.93934 1.93934C7.22064 1.65804 7.60218 1.5 8 1.5H11C11.3978 1.5 11.7794 1.65804 12.0607 1.93934C12.342 2.22064 12.5 2.60218 12.5 3V4.5M14.75 4.5V15C14.75 15.3978 14.592 15.7794 14.3107 16.0607C14.0294 16.342 13.6478 16.5 13.25 16.5H5.75C5.35218 16.5 4.97064 16.342 4.68934 16.0607C4.40804 15.7794 4.25 15.3978 4.25 15V4.5H14.75Z"
											stroke="#F82B60"
											strokeLinecap="round"
											strokeLinejoin="round"
											strokeWidth="1.5"
										/>
										<path
											d="M8 8.25V12.75"
											stroke="#F82B60"
											strokeLinecap="round"
											strokeLinejoin="round"
											strokeWidth="1.5"
										/>
										<path
											d="M11 8.25V12.75"
											stroke="#F82B60"
											strokeLinecap="round"
											strokeLinejoin="round"
											strokeWidth="1.5"
										/>
									</svg>
								</span>
							</div>
						</div>
						<div className="col-md-6">
							<div className="input-group mb-3">
								<div className="input-group-prepend with-color-element">
									<button
										aria-expanded="false"
										aria-haspopup="true"
										className="btn btn-outline-secondary dropdown-toggle"
										data-toggle="dropdown"
										type="button"
									>
										<span
											className="color"
											style={{
												background: 'rgba(154, 161, 175, 1) none repeat scroll 0% 0%'
											}}
										/>
										Pick color
									</button>
									<div className="dropdown-menu">
										<a className="dropdown-item" href="#">
											Action
										</a>
										<a className="dropdown-item" href="#">
											Another action
										</a>
										<a className="dropdown-item" href="#">
											Something else here
										</a>
									</div>
								</div>
								<input
									aria-label="Text input with dropdown button"
									className="form-control"
									type="text"
								/>
								<span className="action-icon">
									<svg
										fill="none"
										height={18}
										viewBox="0 0 19 18"
										width={19}
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M10.25 9.25H9.75V9.75V13.5C9.75 13.6364 9.63636 13.75 9.5 13.75C9.36364 13.75 9.25 13.6364 9.25 13.5V9.75V9.25H8.75H5C4.86364 9.25 4.75 9.13636 4.75 9C4.75 8.86364 4.86364 8.75 5 8.75H8.75H9.25V8.25V4.5C9.25 4.36364 9.36364 4.25 9.5 4.25C9.63636 4.25 9.75 4.36364 9.75 4.5V8.25V8.75H10.25H14C14.1364 8.75 14.25 8.86364 14.25 9C14.25 9.13636 14.1364 9.25 14 9.25H10.25Z"
											fill="#6A7181"
											stroke="#F82B60"
										/>
									</svg>
								</span>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group select-component mb-3">
								<select className="w-100" name="status">
									<option>Status</option>
									<option value="OFFER_PENDING">Offer Pending</option>
									<option value="PRICE_GIVEN">Quoted</option>
									<option value="PRODUCT_SOLD">Design Sold</option>
									<option value="ORDER_PLACED">Order Placed</option>
								</select>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group radio-component mb-3">
								<p className="price-type regular-14">Is it nitex product?</p>
								<input id="yes" name="answer" type="radio" defaultValue="Yes" />
								<label htmlFor="yes">Yes</label>
								<input id="no" name="answer" type="radio" defaultValue="No" />
								<label htmlFor="no">No</label>
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group">
								<label htmlFor>Comments or remarks</label>
								<textarea id name defaultValue={''} />
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							<h5 className="mt-5">Default----36 PX</h5>
						</div>
						<div className="col-md-6">
							<div className="form-group size36">
								<label htmlFor>Label Text</label>
								<input placeholder="Placeholder Text" type="text" />
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group size36">
								<label htmlFor>Label Text</label>
								<div className="with-icon left-icon right-icon">
									<span className="left-icon">
										<svg
											fill="none"
											height={17}
											viewBox="0 0 18 17"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M16.6484 6.04L11.8084 5.62L9.91836 1.17C9.57836 0.36 8.41836 0.36 8.07836 1.17L6.18836 5.63L1.35836 6.04C0.478364 6.11 0.118364 7.21 0.788364 7.79L4.45836 10.97L3.35836 15.69C3.15836 16.55 4.08836 17.23 4.84836 16.77L8.99836 14.27L13.1484 16.78C13.9084 17.24 14.8384 16.56 14.6384 15.7L13.5384 10.97L17.2084 7.79C17.8784 7.21 17.5284 6.11 16.6484 6.04ZM8.99836 12.4L5.23836 14.67L6.23836 10.39L2.91836 7.51L7.29836 7.13L8.99836 3.1L10.7084 7.14L15.0884 7.52L11.7684 10.4L12.7684 14.68L8.99836 12.4Z"
												fill="#9AA1AF"
											/>
										</svg>
									</span>
									<input placeholder="Placeholder Text" type="text" />
									<span className="right-icon">
										<svg
											fill="none"
											height={17}
											viewBox="0 0 18 17"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M16.6484 6.04L11.8084 5.62L9.91836 1.17C9.57836 0.36 8.41836 0.36 8.07836 1.17L6.18836 5.63L1.35836 6.04C0.478364 6.11 0.118364 7.21 0.788364 7.79L4.45836 10.97L3.35836 15.69C3.15836 16.55 4.08836 17.23 4.84836 16.77L8.99836 14.27L13.1484 16.78C13.9084 17.24 14.8384 16.56 14.6384 15.7L13.5384 10.97L17.2084 7.79C17.8784 7.21 17.5284 6.11 16.6484 6.04ZM8.99836 12.4L5.23836 14.67L6.23836 10.39L2.91836 7.51L7.29836 7.13L8.99836 3.1L10.7084 7.14L15.0884 7.52L11.7684 10.4L12.7684 14.68L8.99836 12.4Z"
												fill="#9AA1AF"
											/>
										</svg>
									</span>
								</div>
								<div className="helper-text">
									<div className="left">
										<svg
											fill="none"
											height={14}
											viewBox="0 0 14 14"
											width={14}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M6.00184 2.25179L1.06101 10.5001C0.959139 10.6765 0.905238 10.8765 0.904668 11.0803C0.904097 11.284 0.956877 11.4843 1.05776 11.6613C1.15864 11.8382 1.3041 11.9857 1.47967 12.089C1.65524 12.1923 1.85481 12.2479 2.05851 12.2501H11.9402C12.1439 12.2479 12.3434 12.1923 12.519 12.089C12.6946 11.9857 12.84 11.8382 12.9409 11.6613C13.0418 11.4843 13.0946 11.284 13.094 11.0803C13.0934 10.8765 13.0395 10.6765 12.9377 10.5001L7.99684 2.25179C7.89285 2.08035 7.74643 1.93861 7.57171 1.84024C7.39698 1.74186 7.19985 1.69019 6.99934 1.69019C6.79883 1.69019 6.6017 1.74186 6.42698 1.84024C6.25225 1.93861 6.10583 2.08035 6.00184 2.25179V2.25179Z"
												stroke="#6A7181"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M7 5.25V7.58333"
												stroke="#6A7181"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M7 9.91666H7.00583"
												stroke="#6A7181"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</svg>
										<span>Helper Text</span>
									</div>
									<div className="right">5/10</div>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group size36">
								<label htmlFor>Label Text</label>
								<div className="with-icon left-icon">
									<span className="left-icon">
										<svg
											fill="none"
											height={17}
											viewBox="0 0 18 17"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M16.6484 6.04L11.8084 5.62L9.91836 1.17C9.57836 0.36 8.41836 0.36 8.07836 1.17L6.18836 5.63L1.35836 6.04C0.478364 6.11 0.118364 7.21 0.788364 7.79L4.45836 10.97L3.35836 15.69C3.15836 16.55 4.08836 17.23 4.84836 16.77L8.99836 14.27L13.1484 16.78C13.9084 17.24 14.8384 16.56 14.6384 15.7L13.5384 10.97L17.2084 7.79C17.8784 7.21 17.5284 6.11 16.6484 6.04ZM8.99836 12.4L5.23836 14.67L6.23836 10.39L2.91836 7.51L7.29836 7.13L8.99836 3.1L10.7084 7.14L15.0884 7.52L11.7684 10.4L12.7684 14.68L8.99836 12.4Z"
												fill="#9AA1AF"
											/>
										</svg>
									</span>
									<input placeholder="Placeholder Text" type="text" />
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group size36">
								<label htmlFor>Label Text</label>
								<div className="with-icon right-icon">
									<input placeholder="Placeholder Text" type="text" />
									<span className="right-icon">
										<svg
											fill="none"
											height={17}
											viewBox="0 0 18 17"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M16.6484 6.04L11.8084 5.62L9.91836 1.17C9.57836 0.36 8.41836 0.36 8.07836 1.17L6.18836 5.63L1.35836 6.04C0.478364 6.11 0.118364 7.21 0.788364 7.79L4.45836 10.97L3.35836 15.69C3.15836 16.55 4.08836 17.23 4.84836 16.77L8.99836 14.27L13.1484 16.78C13.9084 17.24 14.8384 16.56 14.6384 15.7L13.5384 10.97L17.2084 7.79C17.8784 7.21 17.5284 6.11 16.6484 6.04ZM8.99836 12.4L5.23836 14.67L6.23836 10.39L2.91836 7.51L7.29836 7.13L8.99836 3.1L10.7084 7.14L15.0884 7.52L11.7684 10.4L12.7684 14.68L8.99836 12.4Z"
												fill="#9AA1AF"
											/>
										</svg>
									</span>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="input-group">
								<div className="input-group-prepend">
									<button
										aria-expanded="false"
										aria-haspopup="true"
										className="btn btn-outline-secondary dropdown-toggle"
										data-toggle="dropdown"
										type="button"
									>
										Dropdown
									</button>
									<div className="dropdown-menu">
										<a className="dropdown-item" href="#">
											Action
										</a>
										<a className="dropdown-item" href="#">
											Another action
										</a>
										<a className="dropdown-item" href="#">
											Something else here
										</a>
									</div>
								</div>
								<input
									aria-label="Text input with dropdown button"
									className="form-control"
									type="text"
								/>
							</div>
						</div>
						<div className="col-md-6">
							<div className="input-group">
								<input
									aria-label="Text input with dropdown button"
									className="form-control"
									type="text"
								/>
								<div className="input-group-append">
									<button
										aria-expanded="false"
										aria-haspopup="true"
										className="btn btn-outline-secondary dropdown-toggle"
										data-toggle="dropdown"
										type="button"
									>
										Dropdown
									</button>
									<div className="dropdown-menu">
										<a className="dropdown-item" href="#">
											Action
										</a>
										<a className="dropdown-item" href="#">
											Another action
										</a>
										<a className="dropdown-item" href="#">
											Something else here
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							<h5 className="mt-5">Disable State</h5>
						</div>
						<div className="col-md-6">
							<div className="form-group size36 disabled">
								<label htmlFor>Label Text</label>
								<input disabled placeholder="Placeholder Text" type="text" />
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group size36 disabled">
								<label htmlFor>Label Text</label>
								<div className="with-icon left-icon right-icon">
									<span className="left-icon">
										<svg
											fill="none"
											height={17}
											viewBox="0 0 18 17"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M16.6484 6.04L11.8084 5.62L9.91836 1.17C9.57836 0.36 8.41836 0.36 8.07836 1.17L6.18836 5.63L1.35836 6.04C0.478364 6.11 0.118364 7.21 0.788364 7.79L4.45836 10.97L3.35836 15.69C3.15836 16.55 4.08836 17.23 4.84836 16.77L8.99836 14.27L13.1484 16.78C13.9084 17.24 14.8384 16.56 14.6384 15.7L13.5384 10.97L17.2084 7.79C17.8784 7.21 17.5284 6.11 16.6484 6.04ZM8.99836 12.4L5.23836 14.67L6.23836 10.39L2.91836 7.51L7.29836 7.13L8.99836 3.1L10.7084 7.14L15.0884 7.52L11.7684 10.4L12.7684 14.68L8.99836 12.4Z"
												fill="#9AA1AF"
											/>
										</svg>
									</span>
									<input disabled placeholder="Placeholder Text" type="text" />
									<span className="right-icon">
										<svg
											fill="none"
											height={17}
											viewBox="0 0 18 17"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M16.6484 6.04L11.8084 5.62L9.91836 1.17C9.57836 0.36 8.41836 0.36 8.07836 1.17L6.18836 5.63L1.35836 6.04C0.478364 6.11 0.118364 7.21 0.788364 7.79L4.45836 10.97L3.35836 15.69C3.15836 16.55 4.08836 17.23 4.84836 16.77L8.99836 14.27L13.1484 16.78C13.9084 17.24 14.8384 16.56 14.6384 15.7L13.5384 10.97L17.2084 7.79C17.8784 7.21 17.5284 6.11 16.6484 6.04ZM8.99836 12.4L5.23836 14.67L6.23836 10.39L2.91836 7.51L7.29836 7.13L8.99836 3.1L10.7084 7.14L15.0884 7.52L11.7684 10.4L12.7684 14.68L8.99836 12.4Z"
												fill="#9AA1AF"
											/>
										</svg>
									</span>
								</div>
								<div className="helper-text">
									<div className="left">
										<svg
											fill="none"
											height={14}
											viewBox="0 0 14 14"
											width={14}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M6.00184 2.25179L1.06101 10.5001C0.959139 10.6765 0.905238 10.8765 0.904668 11.0803C0.904097 11.284 0.956877 11.4843 1.05776 11.6613C1.15864 11.8382 1.3041 11.9857 1.47967 12.089C1.65524 12.1923 1.85481 12.2479 2.05851 12.2501H11.9402C12.1439 12.2479 12.3434 12.1923 12.519 12.089C12.6946 11.9857 12.84 11.8382 12.9409 11.6613C13.0418 11.4843 13.0946 11.284 13.094 11.0803C13.0934 10.8765 13.0395 10.6765 12.9377 10.5001L7.99684 2.25179C7.89285 2.08035 7.74643 1.93861 7.57171 1.84024C7.39698 1.74186 7.19985 1.69019 6.99934 1.69019C6.79883 1.69019 6.6017 1.74186 6.42698 1.84024C6.25225 1.93861 6.10583 2.08035 6.00184 2.25179V2.25179Z"
												stroke="#6A7181"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M7 5.25V7.58333"
												stroke="#6A7181"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M7 9.91666H7.00583"
												stroke="#6A7181"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</svg>
										<span>Helper Text</span>
									</div>
									<div className="right">5/10</div>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group size36 disabled">
								<label htmlFor>Label Text</label>
								<div className="with-icon left-icon">
									<span className="left-icon">
										<svg
											fill="none"
											height={17}
											viewBox="0 0 18 17"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M16.6484 6.04L11.8084 5.62L9.91836 1.17C9.57836 0.36 8.41836 0.36 8.07836 1.17L6.18836 5.63L1.35836 6.04C0.478364 6.11 0.118364 7.21 0.788364 7.79L4.45836 10.97L3.35836 15.69C3.15836 16.55 4.08836 17.23 4.84836 16.77L8.99836 14.27L13.1484 16.78C13.9084 17.24 14.8384 16.56 14.6384 15.7L13.5384 10.97L17.2084 7.79C17.8784 7.21 17.5284 6.11 16.6484 6.04ZM8.99836 12.4L5.23836 14.67L6.23836 10.39L2.91836 7.51L7.29836 7.13L8.99836 3.1L10.7084 7.14L15.0884 7.52L11.7684 10.4L12.7684 14.68L8.99836 12.4Z"
												fill="#9AA1AF"
											/>
										</svg>
									</span>
									<input disabled placeholder="Placeholder Text" type="text" />
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group size36 disabled">
								<label htmlFor>Label Text</label>
								<div className="with-icon right-icon">
									<input disabled placeholder="Placeholder Text" type="text" />
									<span className="right-icon">
										<svg
											fill="none"
											height={17}
											viewBox="0 0 18 17"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M16.6484 6.04L11.8084 5.62L9.91836 1.17C9.57836 0.36 8.41836 0.36 8.07836 1.17L6.18836 5.63L1.35836 6.04C0.478364 6.11 0.118364 7.21 0.788364 7.79L4.45836 10.97L3.35836 15.69C3.15836 16.55 4.08836 17.23 4.84836 16.77L8.99836 14.27L13.1484 16.78C13.9084 17.24 14.8384 16.56 14.6384 15.7L13.5384 10.97L17.2084 7.79C17.8784 7.21 17.5284 6.11 16.6484 6.04ZM8.99836 12.4L5.23836 14.67L6.23836 10.39L2.91836 7.51L7.29836 7.13L8.99836 3.1L10.7084 7.14L15.0884 7.52L11.7684 10.4L12.7684 14.68L8.99836 12.4Z"
												fill="#9AA1AF"
											/>
										</svg>
									</span>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="input-group disabled">
								<div className="input-group-prepend">
									<button
										aria-expanded="false"
										aria-haspopup="true"
										className="btn btn-outline-secondary dropdown-toggle"
										data-toggle="dropdown"
										type="button"
									>
										Dropdown
									</button>
									<div className="dropdown-menu">
										<a className="dropdown-item" href="#">
											Action
										</a>
										<a className="dropdown-item" href="#">
											Another action
										</a>
										<a className="dropdown-item" href="#">
											Something else here
										</a>
									</div>
								</div>
								<input
									aria-label="Text input with dropdown button"
									className="form-control"
									disabled
									type="text"
								/>
							</div>
						</div>
						<div className="col-md-6">
							<div className="input-group  disabled">
								<input
									aria-label="Text input with dropdown button"
									className="form-control"
									disabled
									type="text"
								/>
								<div className="input-group-append">
									<button
										aria-expanded="false"
										aria-haspopup="true"
										className="btn btn-outline-secondary dropdown-toggle"
										data-toggle="dropdown"
										type="button"
									>
										Dropdown
									</button>
									<div className="dropdown-menu">
										<a className="dropdown-item" href="#">
											Action
										</a>
										<a className="dropdown-item" href="#">
											Another action
										</a>
										<a className="dropdown-item" href="#">
											Something else here
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							<h5 className="mt-5">Input field Feedback message</h5>
						</div>
						<div className="col-md-6">
							<div className="form-group">
								<label htmlFor>Label Text</label>
								<div className="with-icon left-icon right-icon">
									<span className="left-icon">
										<svg
											fill="none"
											height={17}
											viewBox="0 0 18 17"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M16.6484 6.04L11.8084 5.62L9.91836 1.17C9.57836 0.36 8.41836 0.36 8.07836 1.17L6.18836 5.63L1.35836 6.04C0.478364 6.11 0.118364 7.21 0.788364 7.79L4.45836 10.97L3.35836 15.69C3.15836 16.55 4.08836 17.23 4.84836 16.77L8.99836 14.27L13.1484 16.78C13.9084 17.24 14.8384 16.56 14.6384 15.7L13.5384 10.97L17.2084 7.79C17.8784 7.21 17.5284 6.11 16.6484 6.04ZM8.99836 12.4L5.23836 14.67L6.23836 10.39L2.91836 7.51L7.29836 7.13L8.99836 3.1L10.7084 7.14L15.0884 7.52L11.7684 10.4L12.7684 14.68L8.99836 12.4Z"
												fill="#9AA1AF"
											/>
										</svg>
									</span>
									<input placeholder="Placeholder Text" type="text" />
									<span className="right-icon">
										<svg
											fill="none"
											height={17}
											viewBox="0 0 18 17"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M16.6484 6.04L11.8084 5.62L9.91836 1.17C9.57836 0.36 8.41836 0.36 8.07836 1.17L6.18836 5.63L1.35836 6.04C0.478364 6.11 0.118364 7.21 0.788364 7.79L4.45836 10.97L3.35836 15.69C3.15836 16.55 4.08836 17.23 4.84836 16.77L8.99836 14.27L13.1484 16.78C13.9084 17.24 14.8384 16.56 14.6384 15.7L13.5384 10.97L17.2084 7.79C17.8784 7.21 17.5284 6.11 16.6484 6.04ZM8.99836 12.4L5.23836 14.67L6.23836 10.39L2.91836 7.51L7.29836 7.13L8.99836 3.1L10.7084 7.14L15.0884 7.52L11.7684 10.4L12.7684 14.68L8.99836 12.4Z"
												fill="#9AA1AF"
											/>
										</svg>
									</span>
								</div>
								<div className="helper-text info-text">
									<div className="left">
										<svg
											fill="none"
											height={18}
											viewBox="0 0 18 18"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M9 2C5.13438 2 2 5.13438 2 9C2 12.8656 5.13438 16 9 16C12.8656 16 16 12.8656 16 9C16 5.13438 12.8656 2 9 2ZM9.5 12.375C9.5 12.4438 9.44375 12.5 9.375 12.5H8.625C8.55625 12.5 8.5 12.4438 8.5 12.375V8.125C8.5 8.05625 8.55625 8 8.625 8H9.375C9.44375 8 9.5 8.05625 9.5 8.125V12.375ZM9 7C8.80374 6.99599 8.61687 6.91522 8.47948 6.775C8.3421 6.63478 8.26515 6.4463 8.26515 6.25C8.26515 6.0537 8.3421 5.86522 8.47948 5.725C8.61687 5.58478 8.80374 5.50401 9 5.5C9.19626 5.50401 9.38313 5.58478 9.52052 5.725C9.6579 5.86522 9.73485 6.0537 9.73485 6.25C9.73485 6.4463 9.6579 6.63478 9.52052 6.775C9.38313 6.91522 9.19626 6.99599 9 7Z"
												fill="#8A6FD6"
											/>
										</svg>
										<span>Info text</span>
									</div>
									<div className="right">5/10</div>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group">
								<label htmlFor>Label Text</label>
								<div className="with-icon left-icon right-icon">
									<span className="left-icon">
										<svg
											fill="none"
											height={17}
											viewBox="0 0 18 17"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M16.6484 6.04L11.8084 5.62L9.91836 1.17C9.57836 0.36 8.41836 0.36 8.07836 1.17L6.18836 5.63L1.35836 6.04C0.478364 6.11 0.118364 7.21 0.788364 7.79L4.45836 10.97L3.35836 15.69C3.15836 16.55 4.08836 17.23 4.84836 16.77L8.99836 14.27L13.1484 16.78C13.9084 17.24 14.8384 16.56 14.6384 15.7L13.5384 10.97L17.2084 7.79C17.8784 7.21 17.5284 6.11 16.6484 6.04ZM8.99836 12.4L5.23836 14.67L6.23836 10.39L2.91836 7.51L7.29836 7.13L8.99836 3.1L10.7084 7.14L15.0884 7.52L11.7684 10.4L12.7684 14.68L8.99836 12.4Z"
												fill="#9AA1AF"
											/>
										</svg>
									</span>
									<input placeholder="Placeholder Text" type="text" />
									<span className="right-icon">
										<svg
											fill="none"
											height={17}
											viewBox="0 0 18 17"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M16.6484 6.04L11.8084 5.62L9.91836 1.17C9.57836 0.36 8.41836 0.36 8.07836 1.17L6.18836 5.63L1.35836 6.04C0.478364 6.11 0.118364 7.21 0.788364 7.79L4.45836 10.97L3.35836 15.69C3.15836 16.55 4.08836 17.23 4.84836 16.77L8.99836 14.27L13.1484 16.78C13.9084 17.24 14.8384 16.56 14.6384 15.7L13.5384 10.97L17.2084 7.79C17.8784 7.21 17.5284 6.11 16.6484 6.04ZM8.99836 12.4L5.23836 14.67L6.23836 10.39L2.91836 7.51L7.29836 7.13L8.99836 3.1L10.7084 7.14L15.0884 7.52L11.7684 10.4L12.7684 14.68L8.99836 12.4Z"
												fill="#9AA1AF"
											/>
										</svg>
									</span>
								</div>
								<div className="helper-text success-text">
									<div className="left">
										<svg
											fill="none"
											height={14}
											viewBox="0 0 14 14"
											width={14}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M7 0C3.13438 0 0 3.13438 0 7C0 10.8656 3.13438 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13438 10.8656 0 7 0ZM10.0234 4.71406L6.73281 9.27656C6.68682 9.34076 6.62619 9.39306 6.55595 9.42914C6.48571 9.46523 6.40787 9.48405 6.32891 9.48405C6.24994 9.48405 6.17211 9.46523 6.10186 9.42914C6.03162 9.39306 5.97099 9.34076 5.925 9.27656L3.97656 6.57656C3.91719 6.49375 3.97656 6.37813 4.07812 6.37813H4.81094C4.97031 6.37813 5.12187 6.45469 5.21562 6.58594L6.32812 8.12969L8.78438 4.72344C8.87813 4.59375 9.02812 4.51562 9.18906 4.51562H9.92188C10.0234 4.51562 10.0828 4.63125 10.0234 4.71406Z"
												fill="#00C334"
											/>
										</svg>
										<span>Success text</span>
									</div>
									<div className="right">5/10</div>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group">
								<label htmlFor>Label Text</label>
								<div className="with-icon left-icon right-icon">
									<span className="left-icon">
										<svg
											fill="none"
											height={17}
											viewBox="0 0 18 17"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M16.6484 6.04L11.8084 5.62L9.91836 1.17C9.57836 0.36 8.41836 0.36 8.07836 1.17L6.18836 5.63L1.35836 6.04C0.478364 6.11 0.118364 7.21 0.788364 7.79L4.45836 10.97L3.35836 15.69C3.15836 16.55 4.08836 17.23 4.84836 16.77L8.99836 14.27L13.1484 16.78C13.9084 17.24 14.8384 16.56 14.6384 15.7L13.5384 10.97L17.2084 7.79C17.8784 7.21 17.5284 6.11 16.6484 6.04ZM8.99836 12.4L5.23836 14.67L6.23836 10.39L2.91836 7.51L7.29836 7.13L8.99836 3.1L10.7084 7.14L15.0884 7.52L11.7684 10.4L12.7684 14.68L8.99836 12.4Z"
												fill="#9AA1AF"
											/>
										</svg>
									</span>
									<input placeholder="Placeholder Text" type="text" />
									<span className="right-icon">
										<svg
											fill="none"
											height={17}
											viewBox="0 0 18 17"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M16.6484 6.04L11.8084 5.62L9.91836 1.17C9.57836 0.36 8.41836 0.36 8.07836 1.17L6.18836 5.63L1.35836 6.04C0.478364 6.11 0.118364 7.21 0.788364 7.79L4.45836 10.97L3.35836 15.69C3.15836 16.55 4.08836 17.23 4.84836 16.77L8.99836 14.27L13.1484 16.78C13.9084 17.24 14.8384 16.56 14.6384 15.7L13.5384 10.97L17.2084 7.79C17.8784 7.21 17.5284 6.11 16.6484 6.04ZM8.99836 12.4L5.23836 14.67L6.23836 10.39L2.91836 7.51L7.29836 7.13L8.99836 3.1L10.7084 7.14L15.0884 7.52L11.7684 10.4L12.7684 14.68L8.99836 12.4Z"
												fill="#9AA1AF"
											/>
										</svg>
									</span>
								</div>
								<div className="helper-text error-text">
									<div className="left">
										<svg
											fill="none"
											height={14}
											viewBox="0 0 14 14"
											width={14}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M7 0C3.13438 0 0 3.13438 0 7C0 10.8656 3.13438 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13438 10.8656 0 7 0ZM9.58438 9.65938L8.55313 9.65469L7 7.80313L5.44844 9.65312L4.41563 9.65781C4.34688 9.65781 4.29063 9.60312 4.29063 9.53281C4.29063 9.50312 4.30156 9.475 4.32031 9.45156L6.35313 7.02969L4.32031 4.60938C4.30143 4.58647 4.29096 4.5578 4.29063 4.52812C4.29063 4.45937 4.34688 4.40312 4.41563 4.40312L5.44844 4.40781L7 6.25938L8.55156 4.40938L9.58281 4.40469C9.65156 4.40469 9.70781 4.45937 9.70781 4.52969C9.70781 4.55937 9.69688 4.5875 9.67813 4.61094L7.64844 7.03125L9.67969 9.45312C9.69844 9.47656 9.70938 9.50469 9.70938 9.53438C9.70938 9.60313 9.65313 9.65938 9.58438 9.65938Z"
												fill="#F22B2B"
											/>
										</svg>
										<span>Error text</span>
									</div>
									<div className="right">5/10</div>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group">
								<label htmlFor>Label Text</label>
								<div className="with-icon left-icon right-icon">
									<span className="left-icon">
										<svg
											fill="none"
											height={17}
											viewBox="0 0 18 17"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M16.6484 6.04L11.8084 5.62L9.91836 1.17C9.57836 0.36 8.41836 0.36 8.07836 1.17L6.18836 5.63L1.35836 6.04C0.478364 6.11 0.118364 7.21 0.788364 7.79L4.45836 10.97L3.35836 15.69C3.15836 16.55 4.08836 17.23 4.84836 16.77L8.99836 14.27L13.1484 16.78C13.9084 17.24 14.8384 16.56 14.6384 15.7L13.5384 10.97L17.2084 7.79C17.8784 7.21 17.5284 6.11 16.6484 6.04ZM8.99836 12.4L5.23836 14.67L6.23836 10.39L2.91836 7.51L7.29836 7.13L8.99836 3.1L10.7084 7.14L15.0884 7.52L11.7684 10.4L12.7684 14.68L8.99836 12.4Z"
												fill="#9AA1AF"
											/>
										</svg>
									</span>
									<input placeholder="Placeholder Text" type="text" />
									<span className="right-icon">
										<svg
											fill="none"
											height={17}
											viewBox="0 0 18 17"
											width={18}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M16.6484 6.04L11.8084 5.62L9.91836 1.17C9.57836 0.36 8.41836 0.36 8.07836 1.17L6.18836 5.63L1.35836 6.04C0.478364 6.11 0.118364 7.21 0.788364 7.79L4.45836 10.97L3.35836 15.69C3.15836 16.55 4.08836 17.23 4.84836 16.77L8.99836 14.27L13.1484 16.78C13.9084 17.24 14.8384 16.56 14.6384 15.7L13.5384 10.97L17.2084 7.79C17.8784 7.21 17.5284 6.11 16.6484 6.04ZM8.99836 12.4L5.23836 14.67L6.23836 10.39L2.91836 7.51L7.29836 7.13L8.99836 3.1L10.7084 7.14L15.0884 7.52L11.7684 10.4L12.7684 14.68L8.99836 12.4Z"
												fill="#9AA1AF"
											/>
										</svg>
									</span>
								</div>
								<div className="helper-text warning-text">
									<div className="left">
										<svg
											fill="none"
											height={14}
											viewBox="0 0 14 14"
											width={14}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M7 0C3.13438 0 0 3.13438 0 7C0 10.8656 3.13438 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13438 10.8656 0 7 0ZM6.5 3.625C6.5 3.55625 6.55625 3.5 6.625 3.5H7.375C7.44375 3.5 7.5 3.55625 7.5 3.625V7.875C7.5 7.94375 7.44375 8 7.375 8H6.625C6.55625 8 6.5 7.94375 6.5 7.875V3.625ZM7 10.5C6.80374 10.496 6.61687 10.4152 6.47948 10.275C6.3421 10.1348 6.26515 9.9463 6.26515 9.75C6.26515 9.5537 6.3421 9.36522 6.47948 9.225C6.61687 9.08478 6.80374 9.00401 7 9C7.19626 9.00401 7.38313 9.08478 7.52052 9.225C7.6579 9.36522 7.73485 9.5537 7.73485 9.75C7.73485 9.9463 7.6579 10.1348 7.52052 10.275C7.38313 10.4152 7.19626 10.496 7 10.5Z"
												fill="#FCB400"
											/>
										</svg>
										<span>Warning text</span>
									</div>
									<div className="right">5/10</div>
								</div>
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group">
								<label htmlFor>Label Text</label>
								<CustomDropdown
									title="Project type*"
									onItemClick={() => {}}
									selectedItem={''}
									items={[]}
								/>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							<div className="select-component chip-component mb-3 show">
								<label htmlFor="collection">RoleWiseCollection</label>
								<div
									aria-expanded="true"
									aria-haspopup="true"
									className="click-box text-right click mb-1"
									data-toggle="dropdown"
								>
									<div className="all-chips">
										<span>
											Chip1 <img src="../../public/icons/chip-close.svg" />
										</span>
										<span>
											Chip1 <img src="../../public/icons/chip-close.svg" />
										</span>
										<span>
											Chip1 <img src="../../public/icons/chip-close.svg" />
										</span>
										<span>
											Chip1 <img src="../../public/icons/chip-close.svg" />
										</span>
									</div>
									<div className="inputs">
										<input className="border-0" type="text" />
									</div>
									<svg
										fill="none"
										height={24}
										viewBox="0 0 24 24"
										width={24}
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M15.8805 9.29055L12.0005 13.1705L8.12047 9.29055C7.73047 8.90055 7.10047 8.90055 6.71047 9.29055C6.32047 9.68055 6.32047 10.3105 6.71047 10.7005L11.3005 15.2905C11.6905 15.6805 12.3205 15.6805 12.7105 15.2905L17.3005 10.7005C17.6905 10.3105 17.6905 9.68055 17.3005 9.29055C16.9105 8.91055 16.2705 8.90055 15.8805 9.29055Z"
											fill="#9AA1AF"
										/>
									</svg>
								</div>
								<div
									className="dropdown-box dropdown-menu show"
									style={{
										position: 'absolute',
										willChange: 'transform',
										top: '0px',
										left: '0px',
										transform: 'translate3d(15px, 63px, 0px)'
									}}
									x-placement="bottom-start"
								>
									<div className="color-list-box">
										<div className="single-color-item single-item d-flex">
											<div className="one-half color-name">
												<p className="regular-14">
													95% cotton, 5% polyester, GSM 120
												</p>
											</div>
										</div>
										<div className="single-color-item single-item d-flex">
											<div className="one-half color-name">
												<p className="regular-14">Synthetics, 12 GSM</p>
											</div>
										</div>
										<div className="single-color-item single-item d-flex">
											<div className="one-half color-name">
												<p className="regular-14">
													95% cotton, 5% polyester, GSM 120
												</p>
											</div>
										</div>
										<div className="single-color-item single-item d-flex">
											<div className="one-half color-name">
												<p className="regular-14">Synthetics, 12 GSM</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group">
								<label htmlFor>Label Text</label>
								<CreatableSelect
									isMulti
									value={'TEST'}
									onChange={() => {}}
									options={[
										{ label: '01', value: 'Test', id: 1 },
										{ label: '02', value: 'Test1', id: 2 },
										{ label: '03', value: 'Test2', id: 3 }
									]}
									isClearable
								/>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	);
};

export default Input;
